<template>
    <div id="personal">
        <div class="content" v-if="!editState.state">
            <a-button style="margin-left:40px;" @click="editUserInfo">编辑我的个人信息</a-button>
            <a-divider class="line"><span class="f18">个人信息</span></a-divider>
            <div class="user-info-wrap" v-if="userData">
                <div class="left">
                    <div class="img-wrap">
                        <img :src="userData.userInfo.avatarUrl">
                    </div>
                </div>
                <div class="right f16">
                    <div class="row">
                        <span>用户账号：</span>
                        <span>{{userData.userInfo.account}}</span>
                    </div>
                    <div class="row">
                        <span>姓名：</span>
                        <span>{{userData.userInfo.name}}</span>
                    </div>
                    <div class="row">
                        <span>性别：</span>
                        <span>{{userData.userInfo.sex == 1?"男":"女"}}</span>
                    </div>
                    <div class="row">
                        <span>单位名称：</span>
                        <span>{{userData.userInfo.organizationName}}</span>
                    </div>
                    <div class="row">
                        <span>职务：</span>
                        <span>{{userData.userInfo.post}}</span>
                    </div>
                    <div class="row">
                        <span>绑定手机号：</span>
                        <span>{{userData.phone}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-if="editState && editState.state">
            <a-button style="margin-left:40px;" @click="viewUserInfo">查看我的个人信息</a-button>
            <a-divider class="line"></a-divider>
            <div class="user-info-wrap" v-if="userData">
                <div class="left edit">
                    <a-menu
                        style="width: 256px;float:right;margin-right:50px;"
                        mode="inline"
                        theme="light"
                        v-model="editState.type"
                        @click="handleClick" 
                    >
                        <a-menu-item key="base">
                            基本信息
                        </a-menu-item>
                        <a-menu-item key="password">
                            修改密码
                        </a-menu-item>
                        <a-menu-item key="phone" v-if="userData.phone !== '****'">
                            修改绑定手机
                        </a-menu-item>
                    </a-menu>
                </div>
                <div class="right">
                    <UserInfoBase 
                        v-if="editState.type[0] === 'base'"
                        :userData="userData"
                        @getData="getData"
                    />
                    <UserInfoPassword 
                        v-if="editState.type[0] === 'password'" 
                    />
                    <UserInfoPhone 
                        v-if="editState.type[0] === 'phone'" 
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserInfoBase from "./UserInfoBase.vue";
import UserInfoPassword from "./UserInfoPassword.vue";
import UserInfoPhone from "./UserInfoPhone.vue";
import UrlApi from "@/utils/UrlApi.js";
export default {
    name:"Personal",
    data () {
        return {
            userData: null
        };
    },
    created(){
        this.getData();
    },
    components:{
        UserInfoBase,
        UserInfoPassword,
        UserInfoPhone
    },
    computed:{
        editState(){
            let state = false;
            let type = [];
            let {edit} = this.$route.query;
            if(edit){
                state = true;
                type = [edit];
            }
            return {state,type};
        },
        userName: {
            get() {
                return this.$store.state.userName
            },
            set(value){
                this.$store.commit('updateUserName',value)
            }
        },
    },
    methods: {
        // 菜单切换
        handleClick(openKeys){
            let {key} = openKeys;
            this.$router.push({name:"Personal",query:{edit:key}});
        },
        // 查看我的个人信息
        viewUserInfo(){
            this.$router.push({name:"Personal"});
        },
        // 编辑我的个人信息
        editUserInfo(){
            this.$router.push({name:"Personal",query:{edit:"base"}});
        },
        // 获取个人信息
        getData(){
            let url1 = UrlApi.personalInfoValid; 
            let url2 = UrlApi.personalInfoOutline;
            let url3 = UrlApi.personalInfo;
            let token = this.$store.getters.getToken;
            let userId = this.$store.getters.getUserId;
            let p1 = new Promise((resolve) => {
                this.$http.get(url1,{
                    params: {
                        userId:userId
                    },
                    headers:{
                       'Authorization': token
                    }
                }).then(res=>{
                    resolve(res);
                })
            })
            let p2 = new Promise((resolve) => {
                this.$http.get(url2,{
                    params: {
                        userId:userId
                    },
                    headers:{
                        'Authorization': token
                    }
                }).then(res=>{
                    resolve(res);
                })
            })
            let params = `userId=${userId}`;
            let p3 = new Promise((resolve) => {
                this.$http.post(url3,params,{
                    headers:{
                        'Authorization': token
                    }
                }).then(res=>{
                    resolve(res);
                })
            })
            Promise.all([p1,p2,p3]).then((result) => {
                this.initData(result);
            })
        },
        // 初始化信息
        initData(result){
            // console.log(result);
            this.userData = result[2].data.data;

            this.userName = result[2].data.data.userInfo.name
        }
    }
}

</script>
<style lang="less" scoped>
    #personal {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 145px);
        height: 100%;
        padding: 30px;

        .content {
            min-height: calc(100vh - 205px);
            background-color: #ffffff;
            padding-top: 20px;
            .line {
                margin-bottom: 60px;
            }
            .row {
                & > span:nth-of-type(1){
                    display: inline-block;
                    width: 100px;
                    padding: 5px 0;
                }
                & > span:nth-of-type(2){
                    color: #333333; 
                }
            }
            .user-info-wrap {
                display: flex;
                justify-content: center;
                & > div {
                    &.edit {
                        width: 25%;
                    }
                    width: 50%;
                }
                .img-wrap {
                    float: right;
                    margin-right: 100px;
                    width: 150px;
                    height: 150px;
                    margin-top: 30px;
                    overflow: hidden;
                    border-radius: 100%;
                    border: 1px solid #CCCCCC;
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
</style>